var map = {
	"./etkinlikler.svg": 2113,
	"./kendinitestet.svg": 2616,
	"./masterclassegitim.svg": 7864,
	"./mobiluygulamalar.svg": 2612,
	"./noahmasterworld.svg": 3339,
	"./portal.svg": 6596,
	"./sertifikalar.svg": 3040,
	"./shopwebsiteleri.svg": 7682,
	"./showroom.svg": 8291,
	"./ucretsizegitim.svg": 8369,
	"./urunler.svg": 8126
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8263;